import {
  FieldMergeFunction,
  FieldReadFunction,
  TypePolicies,
} from '@apollo/client';
import { mergeDeep } from '@apollo/client/utilities';
import { queryMap } from './resolvers';
import {
  restResourceFieldPolicies,
  batchRestResourceFieldPolicies,
  readMemberMe,
} from './restResourceResolver/restResourceCacheRedirects';

const basicObjectMerge: FieldMergeFunction<unknown> = (existing, incoming) => {
  return mergeDeep(existing, incoming);
};
// Constructs the read function that will return provided default value in case of cache miss
const readWithDefault = <T>(defaultValue: T): FieldReadFunction<T> => {
  return (existing) => (existing !== undefined ? existing : defaultValue);
};

const fieldPolicies = {
  ...restResourceFieldPolicies(queryMap),
  ...batchRestResourceFieldPolicies(queryMap),
};

export const typePolicies: TypePolicies = {
  Query: {
    // Add fieldPolicies (https://www.apollographql.com/docs/react/advanced/caching/#cache-redirects-with-cacheredirects)
    // for any restResourceResolvers/batchRestResourceResolvers used as Query resolvers to ensure we can grab entities by
    // id
    fields: {
      ...fieldPolicies,
      member: {
        read: readMemberMe,
      },
    },
  },
  Board: {
    fields: {
      prefs: {
        merge: basicObjectMerge,
      },
      templateGallery: {
        merge: basicObjectMerge,
      },
    },
  },
  Card: {
    fields: {
      checklists: {
        read: readWithDefault([]),
      },
      badges: {
        merge: basicObjectMerge,
      },
      cover: {
        merge: basicObjectMerge,
      },
    },
  },
  Checklist: {
    fields: {
      checkItems: {
        read: readWithDefault([]),
      },
      pos: {
        // -1 means position is unknown. See `calcPos` in app/scripts/lib/util/index.js
        read: readWithDefault(-1),
      },
    },
  },
  Enterprise: {
    fields: {
      paidAccount: {
        merge: basicObjectMerge,
      },
    },
  },
  Organization: {
    fields: {
      paidAccount: {
        merge: basicObjectMerge,
      },
      prefs: {
        merge: basicObjectMerge,
      },
    },
  },
  Member: {
    fields: {
      prefs: {
        merge: basicObjectMerge,
      },
      paidAccount: {
        merge: basicObjectMerge,
      },
    },
  },
};
